import React from "react";
import { useSubmitDialogLogic } from "./useSubmitDialogLogic";
import SubmitDialogView from "./SubmitDialogView";

// --- 主元件 (Container) ---
// 職責：連接邏輯與畫面
const SubmitDialog = (props) => {
  const logic = useSubmitDialogLogic(props);
  return <SubmitDialogView id={props.id} {...logic} />;
};

export default SubmitDialog;
